import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-multi-brand-screw-air',
  templateUrl: './multi-brand-screw-air.component.html',
  styleUrls: ['./multi-brand-screw-air.component.scss']
})
export class MultiBrandScrewAirComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
